import script from "./ServiceView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ServiceView.vue?vue&type=script&lang=ts&setup=true"

import "./ServiceView.vue?vue&type=style&index=0&id=e4c9b6f0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4c9b6f0"]])

export default __exports__